import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import "./Forms.css";
import axiosInstance from "../axiosinstance";

export default function EditFirms({ isSidebarExpanded }) {
  const { firm_id } = useParams(); // Retrieve the firm ID from the URL
  console.log(firm_id, "id is retrived");

  const [userData, setUserData] = useState({
    fname: "",
    address: "",
    email: "",
    con_no: "",
    max_sub: "",
    owner_name: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    message: "",
    severity: "",
    open: false,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchFirmDetails = async () => {
      try {
        setIsLoading(true);
        const response = await axiosInstance.get(
          `/api/get_firm_by_id/${firm_id}`
        );
        setUserData({
          fname: response.data.result.firm_name || "",
          address: response.data.result.address || "",
          email: response.data.result.email_id || "",
          con_no: response.data.result.contact_no || "",
          max_sub: response.data.result.max_subsidiaries || "",

          owner_name: response.data.result.owner_name || "",
        });
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching firm details:", error.message);
        setSnackbar({
          message: "Failed to load firm details",
          severity: "error",
          open: true,
        });
        setIsLoading(false);
      }
    };

    fetchFirmDetails();
  }, [firm_id]);

  const validateForm = () => {
    const newErrors = {};
    if (!userData.fname) newErrors.fname = "Firm Name is required";
    if (!userData.address) newErrors.address = "Address is required";
    if (!userData.email || !/\S+@\S+\.\S+/.test(userData.email))
      newErrors.email = "Valid Email is required";
    if (!userData.con_no || !/^[0-9]{10}$/.test(userData.con_no))
      newErrors.con_no = "Valid Contact No is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveClick = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setIsLoading(true);
      const response = await axiosInstance.put(`/api/edit_firm/${firm_id}`, {
        firm_id,
        firm_name: userData.fname,
        address: userData.address,
        owner_name: userData.owner_name,
        contact_no: userData.con_no,
        max_subsidiaries: userData.max_sub,
        email_id: userData.email,
      });

      console.log(response, "response");

      setSnackbar({
        message: "Firm updated successfully",
        severity: "success",
        open: true,
      });
      setTimeout(() => navigate("/super-Admin"), 1000);
    } catch (error) {
      console.error("Error updating firm:", error.message);
      setSnackbar({
        message: "Failed to update firm",
        severity: "error",
        open: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <div
      className={`table-container ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content form-main-body">
        <h1 className="form-title jost-bold">Edit Firm</h1>
        <div className="form-body">
          <form onSubmit={handleSaveClick}>
            {[
              { name: "fname", label: "Firm Name" },
              { name: "address", label: "Address" },
              { name: "email", label: "Email ID" },
              { name: "con_no", label: "Contact Number" },
              { name: "max_sub", label: "Max Subsidiaries" },

              { name: "owner_name", label: "Owner Name" },
            ].map(({ name, label }) => (
              <div className="form-group" key={name}>
                <label className="form-label jost-regular">
                  {label}
                  {name !== "password" && name !== "confirmPassword" && (
                    <span className="required">*</span>
                  )}
                </label>
                <input
                  type={name.includes("password") ? "password" : "text"}
                  className="input-field"
                  placeholder={`Enter ${label}`}
                  name={name}
                  value={userData[name]}
                  onChange={handleChange}
                  required={name !== "password" && name !== "confirmPassword"}
                />
                {errors[name] && (
                  <div className="error-text">{errors[name]}</div>
                )}
              </div>
            ))}

            <div className="button-group">
              <button
                type="button"
                className="btn btn-cancel"
                onClick={handleBack}
              >
                CANCEL
              </button>
              <button
                type="submit"
                className="btn btn-save"
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "SAVE"}
              </button>
            </div>
          </form>
          {snackbar.open && (
            <div className={`snackbar ${snackbar.severity}`}>
              {snackbar.message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
